<div [class.p-floatlabel]="floatLabel()">
  <p-password
    id="password"
    aria-describedby="password"
    [toggleMask]="toggleMask()"
    [strongRegex]="passwordComplexity"
    [feedback]="feedback()"
    [disabled]="_disabled()"
    [(ngModel)]="password"
    [attr.aria-describedby]="'Auth.Password' | translate"
    (ngModelChange)="onChange($event)"
    (onBlur)="onTouched()"
    class="w-full position-{{ position() }}"
    appendTo="body">
    <ng-template pTemplate="header">
      <span class="password-header">{{ 'Auth.EnterAPassword' | translate }}</span>
      <div class="w-full h-1rem"></div>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-divider class="p-divider-gray" />
      <div class="w-full h-1rem"></div>
      <span class="password-footer">{{ 'Auth.PasswordShouldBe' | translate }}</span>
      <ul class="p-0 py-1 md:py-2 m-0">
        <li class="flex mb-1">
          @if (hasAtLeastOne(ECondition.Lowercase)) {
            <app-icon icon="icon-check" color="success" />
          } @else {
            <app-icon icon="icon-x" color="danger" />
          }
          <span class="password-footer"> {{ 'Auth.AtLeastOneLowercase' | translate }}</span>
        </li>
        <li class="flex mb-1">
          @if (hasAtLeastOne(ECondition.Uppercase)) {
            <app-icon icon="icon-check" color="success" />
          } @else {
            <app-icon icon="icon-x" color="danger" />
          }
          <span class="password-footer">{{ 'Auth.AtLeastOneUppercase' | translate }}</span>
        </li>
        <li class="flex mb-1">
          @if (hasAtLeastOne(ECondition.Numeric)) {
            <app-icon icon="icon-check" color="success" />
          } @else {
            <app-icon icon="icon-x" color="danger" />
          }
          <span class="password-footer">{{ 'Auth.AtLeastOneNumeric' | translate }}</span>
        </li>
        <li class="flex mb-1">
          @if (hasAtLeastOne(ECondition.Special)) {
            <app-icon icon="icon-check" color="success" />
          } @else {
            <app-icon icon="icon-x" color="danger" />
          }
          <span class="password-footer"> {{ 'Auth.AtLeastOneSpecialCharacter' | translate }}</span>
        </li>
        <li class="flex mb-1">
          @if (hasAtLeastOne(ECondition.CharacterLengthRange)) {
            <app-icon icon="icon-check" color="success" />
          } @else {
            <app-icon icon="icon-x" color="danger" />
          }
          <span class="password-footer"> {{ 'Auth.Between12To128Characters' | translate }}</span>
        </li>
      </ul>
    </ng-template>
  </p-password>
  @if (floatLabel()) {
    <label class="floatLabel" htmlFor="password">{{ floatLabel() }}</label>
  }
</div>
